import { post } from './axios_call';

export default async (title) => post('catalogues', { title });
